import React, { useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Box, Typography, CircularProgress } from "@material-ui/core"
import { useTheme } from "@material-ui/styles"
import CheckIcon from "@material-ui/icons/Check"
import useStyles from "./styles"
import PropTypes from "prop-types"
import upgradeAd from "../../../../assets/images/upgradeAd.png"
import moment from "moment"
import classNames from "classnames"
import { toggleDigitalSignatureDialog } from "../../../../actions/billingDialogs"
import { _toggleLoginDialog } from "../../../../actions/authentication"
import { updateCrewDealMemoStatus } from "../../../../actions/billing-crew-client"
import { openSnackBar } from "../../../../actions/snack-bar"

import GreenButton from "../../Common/GreenButton/index"
import {
  Button,
  Card,
} from "../../../../../node_modules/@material-ui/core/index"
import {
  createStripeAccount,
  createAdwaStripeAccount,
} from "../../../../actions/users"

const CrewBillingRightActions = ({
  crewDealMemo = {},
  setCrewDealMemo = () => {},
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const theme = useTheme()

  const [working, toggleWorking] = useState(false)
  const [createLoading, setCreateLoading] = useState(false)

  const companyLogo =
    crewDealMemo &&
    crewDealMemo.company_logo_image &&
    JSON.parse(crewDealMemo.company_logo_image).url

  const confirmed =
    crewDealMemo &&
    crewDealMemo.user &&
    Boolean(crewDealMemo.user.bill_accepted)

  const crewMember = crewDealMemo && crewDealMemo.user
  console.log("crewMember", crewDealMemo)
  const hasStripeAccount =
    crewMember.stripe_account_id === null || crewMember.complete === 0
      ? false
      : true
  const hasAdwaStripeAccount = crewMember.adwa_stripe_account_id ? true : false
  //console.log("hasAdwaStripeAccount", hasAdwaStripeAccount)
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )

  const confirmAndSubmitBilling = dialogVals => {
    toggleWorking(true)
    let data = {
      action: "update-status-bill-accepted",
      emailTo: crewDealMemo.representative_email
        ? crewDealMemo.representative_email
        : crewDealMemo.creator_email,
      //emailTo: "",
      bill_approval_signature: dialogVals.fullName,
      bill_approval_terms_accepted: +dialogVals.termsAccepted,
    }
    dispatch(updateCrewDealMemoStatus(data, crewMember.shoot_role_id))
      .then(() => {
        toggleWorking(false)
        setCrewDealMemo(oldState => {
          let updatedUser = {
            ...oldState.user,
            user_status: "bill_accepted",
            bill_accepted: 1,
            bill_approval_signature: data.bill_approval_signature,
            bill_approval_terms_accepted: +data.bill_approval_terms_accepted,
            bill_accepted_date_time: moment().format("M/D/YY[ @ ]h:mm A"),
          }
          return { ...oldState, user: updatedUser }
        })
        dispatch(openSnackBar({ message: "You have submitted your crew bill" }))
      })
      .catch(err => {
        console.log(err)
        toggleWorking(false)
        dispatch(openSnackBar({ message: "Error submitting your crew bill" }))
      })
  }

  const openDigitalSignatureDialog = () => {
    let data = {
      headerLogo: companyLogo,
      acceptFunc: confirmAndSubmitBilling,
      hasStripeAccount: hasStripeAccount,
    }
    Object.keys(authenticatedUser).length > 0
      ? dispatch(toggleDigitalSignatureDialog(true, data))
      : dispatch(_toggleLoginDialog(true))
  }

  const paid = useMemo(
    () => {
      return (
        Boolean(crewDealMemo.second_paid || crewDealMemo.full_paid) || false
      )
    },
    [crewDealMemo]
  )

  const billSubmitted = useMemo(
    () => {
      return (
        Boolean(
          crewMember.user_status === "approved" ||
            crewMember.user_status === "bill_accepted"
        ) || false
      )
    },
    [crewMember]
  )

  let checkList = [
    {
      label: "You submitted your bill",
      key: "submitted",
      date: crewMember.bill_accepted_date_time || false,
      accomplished: billSubmitted,
    },
    // {
    //   label: "Invoice sent to client",
    //   key: "sent",
    //   date: crewDealMemo.invoice_sent_date_time,
    //   accomplished: Boolean(
    //     crewDealMemo.invoice_sent || crewDealMemo.invoice_accepted
    //   ),
    // },
    // {
    //   label: "Client Paid",
    //   key: "paid",
    //   date: crewDealMemo.full_paid_date || crewDealMemo.second_paid_date,
    //   accomplished: paid,
    // },
  ]

  const handleConnectStripe = () => {
    if (
      Object.keys(authenticatedUser).length > 0 &&
      authenticatedUser.id === crewDealMemo.user.user_id
    ) {
      setCreateLoading(true)
      dispatch(createStripeAccount())
        .then(res => {
          if (res.hasOwnProperty("url")) {
            window.open(res.url.url)
          }
          if (res.message === "User are gtt member.") {
            dispatch(openSnackBar({ message: "User are gtt member" }))
          }
          setCreateLoading(false)
        })
        .catch(error => {
          console.log("error", error)
          setCreateLoading(false)
        })
    } else {
      dispatch(_toggleLoginDialog(true))
    }
  }

  const handleConnectAdwaStripe = () => {
    if (
      Object.keys(authenticatedUser).length > 0 &&
      authenticatedUser.id === crewDealMemo.user.user_id
    ) {
      setCreateLoading(true)
      dispatch(createAdwaStripeAccount())
        .then(res => {
          if (res.hasOwnProperty("url")) {
            window.open(res.url.url)
          }
          if (res.message === "User are gtt member.") {
            dispatch(openSnackBar({ message: "User are gtt member" }))
          }
          setCreateLoading(false)
        })
        .catch(error => {
          console.log("error", error)
          setCreateLoading(false)
        })
    } else {
      dispatch(_toggleLoginDialog(true))
    }
  }

  return !confirmed ? (
    <Box>
      <Box alignSelf="center" mt={2}>
        <GreenButton
          variant="contained"
          fullWidth
          onClick={openDigitalSignatureDialog}
        >
          {working ? (
            <CircularProgress
              size={20}
              style={{ color: "#fff", margin: "4px 0" }}
            />
          ) : (
            "Confirm & Submit"
          )}
        </GreenButton>
      </Box>
      {crewDealMemo.crewmama_or_gtt === "adwa" &&
        !hasAdwaStripeAccount && (
          <Box display="flex" justifyContent="center">
            <Card
              style={{
                marginTop: "50px",
                display: "flex",
                justifyContent: "center",
                border: `2px solid ${theme.palette.error.main}`,
                width: "80%",
              }}
            >
              <Box width="60%" marginTop="20px">
                <Typography variant="h3">Connect to ADWA Stripe</Typography>
                <Typography variant="subtitle1" style={{ marginTop: "15px" }}>
                  To be paid you need to create an account in Stripe
                </Typography>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleConnectAdwaStripe}
                  disabled={createLoading}
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                >
                  Connect to Stripe
                </Button>
              </Box>
            </Card>
          </Box>
        )}
      {crewDealMemo.crewmama_or_gtt !== "adwa" &&
        !hasStripeAccount && (
          <Box display="flex" justifyContent="center">
            <Card
              style={{
                marginTop: "50px",
                display: "flex",
                justifyContent: "center",
                border: `2px solid ${theme.palette.error.main}`,
                width: "80%",
              }}
            >
              <Box width="60%" marginTop="20px">
                <Typography variant="h3">Connect to Stripe</Typography>
                <Typography variant="subtitle1" style={{ marginTop: "15px" }}>
                  To be paid you need to create an account in Stripe
                </Typography>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleConnectStripe}
                  disabled={createLoading}
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                >
                  Connect to Stripe
                </Button>
              </Box>
            </Card>
          </Box>
        )}
      <img
        src={upgradeAd}
        alt="organization-logo"
        style={{
          marginLeft: "auto",
          display: "flex",
          alignItems: "center",
          marginRight: "auto",
          width: "50%",
          marginTop: "20px",
          borderRadius: "16px",
        }}
      />
    </Box>
  ) : (
    <Box display="flex" flexDirection="column" mt={2} mb={2}>
      <Box alignSelf="flex-end">
        <Typography style={{ color: theme.palette.success.main }}>
          Completed
        </Typography>
      </Box>

      {checkList.map(bullet => {
        return (
          <Box className={classes.item} key={bullet.key}>
            <Box display="flex" flexDirection="column" alignItems="flex-start">
              <Typography variant="h4" style={{ textAlign: "left" }}>
                {bullet.label}
              </Typography>
              {bullet.date && (
                <Typography variant="subtitle1" className={classes.date}>
                  on {moment(bullet.date).format("M/D/YY[ @ ]h:mm A")}
                </Typography>
              )}
            </Box>
            <Box
              className={classNames(classes.statusDot, {
                [classes.acceptedDot]: bullet.accomplished,
              })}
            >
              {bullet.accomplished && (
                <CheckIcon className={classes.checkIcon} />
              )}
            </Box>
          </Box>
        )
      })}
      {crewDealMemo.crewmama_or_gtt === "adwa" &&
        !hasAdwaStripeAccount && (
          <Box display="flex" justifyContent="center">
            <Card
              style={{
                marginTop: "50px",
                display: "flex",
                justifyContent: "center",
                border: `2px solid ${theme.palette.error.main}`,
                width: "80%",
              }}
            >
              <Box width="60%" marginTop="20px">
                <Typography variant="h3">Connect to ADWA Stripe</Typography>
                <Typography variant="subtitle1" style={{ marginTop: "15px" }}>
                  To be paid you need to create an account in Stripe
                </Typography>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleConnectAdwaStripe}
                  disabled={createLoading}
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                >
                  Connect to Stripe
                </Button>
              </Box>
            </Card>
          </Box>
        )}
      {crewDealMemo.crewmama_or_gtt !== "adwa" &&
        !hasStripeAccount && (
          <Box display="flex" justifyContent="center">
            <Card
              style={{
                marginTop: "50px",
                display: "flex",
                justifyContent: "center",
                border: `2px solid ${theme.palette.error.main}`,
                width: "80%",
              }}
            >
              <Box width="60%" marginTop="20px">
                <Typography variant="h3">Connect to Stripe</Typography>
                <Typography variant="subtitle1" style={{ marginTop: "15px" }}>
                  To be paid you need to create an account in Stripe
                </Typography>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleConnectStripe}
                  disabled={createLoading}
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                >
                  Connect to Stripe
                </Button>
              </Box>
            </Card>
          </Box>
        )}
      <img
        src={upgradeAd}
        alt="organization-logo"
        style={{
          marginLeft: "auto",
          display: "flex",
          alignItems: "center",
          marginRight: "auto",
          width: "50%",
          marginTop: "20px",
          borderRadius: "16px",
        }}
      />
    </Box>
  )
}

CrewBillingRightActions.propTypes = {
  crewDealMemo: PropTypes.object,
  setCrewDealMemo: PropTypes.func,
}

export default CrewBillingRightActions
